import apiClient from "@/axios";

export const getAppLibrary = async (page = 1, sort = 'created_at', order = 'asc', platformId = null, listId = null, searchQuery = null) => {
  const response = await apiClient.post("/user/library/app/all", {
    page: page, 
    sort: sort,
    order: order,
    platformId: platformId,
    listId: listId,
    searchQuery: searchQuery
  });
  return response;
};

export const getAppFromLibrary = async (appId) => {
  const response = await apiClient.post("/user/library/app/get-app", {
    appId: appId,
  });
  return response;
};

export const addToLibrary = async (appId) => {
  const response = await apiClient.post("/user/library/app/add-app", {
    appId: appId,
  });
  return response;
};

export const removeAppFromLibrary = async (appId) => {
  const response = await apiClient.post("/user/library/app/remove-app", {
    appId: appId,
  });
  return response;
};

export const removeAppFromAll = async (appId) => {
  const response = await apiClient.post(
    "/user/library/app/remove-app-from-all",
    {
      appId: appId,
    }
  );
  return response;
};

export const updateNotification = async (appId, isNotification) => {
  const response = await apiClient.post(
    "/user/library/app/update-notification",
    {
      appId: appId,
      isNotification: isNotification,
    }
  );
  return response;
};

export const getUnaddedApp = async (developerId) => {
  const response = await apiClient.post("/user/library/app/unadded-apps", {
    developerId: developerId,
  });
  return response;
};
